import React from "react";

export interface IIconUser {}

export default function IconUser() {
  return (
    <svg
      className="h-6 w-6"
      preserveAspectRatio="none"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
        className="fill-brij-Peach stroke-brij-Peach"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M12 14C5.51253 14 5.03289 19.6831 5.00149 20.8079C4.99847 20.9161 5.08614 21 5.19437 21H18.8056C18.9139 21 19.0015 20.9161 18.9985 20.8079C18.9671 19.6831 18.4875 14 12 14Z"
        className="fill-brij-Peach stroke-brij-Peach"
        strokeWidth="2"
      ></path>
    </svg>
  );
}
